import { createSelector } from 'reselect'

import { taxInformationModalSelector } from '../../selectors'

export const initialValuesSelector = createSelector(
  taxInformationModalSelector,
  ({ initialValues }) => initialValues
)

export const updateTaxIdAndShippingDataStatusSelector = createSelector(
  taxInformationModalSelector,
  ({ updateTaxIdAndShippingAddress }) => updateTaxIdAndShippingAddress
)
